import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { Inscricao } from '../inscricao/inscricao';

@Component({
  selector: 'inscricao-filtro',
  templateUrl: './inscricao-filtro.component.html',
  styleUrls: [ './inscricao-filtro.component.css' ]
})
export class InscricaoFiltroComponent implements OnInit {
  public filtro: Inscricao = new Inscricao();
  @Output() filtroEmitido: EventEmitter<Inscricao> = new EventEmitter<Inscricao>();
  // construtor
  constructor(  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {

  }
  // busca com filtro
  public filtrar(): void {
    this.filtroEmitido.emit(this.filtro);
  }

}
